module.exports = __webpack_public_path__ + "img/permatava-light.d12926dc.png";